export default __webpack_public_path__ + "static/media/image.56dc6bb1.jpg";